import React from "react";
import { Dropdown, Option } from "@fluentui/react-components";

const TypeDropdown = ({ value, onChange, options, className }) => {
  const selectedOption = options.find((opt) => opt.key === value);

  return (
    <Dropdown
      className={className}
      placeholder="Select entity type"
      selectedOptions={value ? [value] : []}
      value={selectedOption?.label || "Select entity type"}
      onOptionSelect={(_, data) => {
        const selected = data.optionValue;
        if (selected) {
          onChange(selected);
        }
      }}
    >
      {options.map((opt) => (
        <Option key={opt.key} value={opt.key}>
          {opt.label}
        </Option>
      ))}
    </Dropdown>
  );
};

export default TypeDropdown;
